<template>
  <span v-if="assinado" class="assinar__botao-link desativado">
    <i class="fas fa-check" aria-hidden="true"/>
    Assinado
  </span>
<!--  <a v-else id="botaoAssinarComBorda" @click="$emit('assinarDocumento')" class="assinar__botao-link">-->
  <a v-else id="botaoAssinarComBorda" :href="documentoVirtualizadoUrl" target="_blank" class="assinar__botao-link">
    <i class="fas fa-signature" aria-hidden="true"/>
    Assinar
  </a>
</template>

<script>
export default {
    name: 'BotaoAssinarComBorda',
    props:{
        assinado:{
            type: Boolean,
            default: false
        },
        documentoVirtualizadoUrl:{
            type: String,
            default: ''
        }
    }

}
</script>

<style scoped lang="stylus">
  .assinar
    color #888
    &__botao-link
      background-color #fff
      color #888
      padding 5px 10px 7px 5px
      min-width 50px
      margin-right 10px
      border 0.1px solid #CACFD2
      text-decoration none

      i
        color #777 !important
        font-size 13px
        top 0

      &:hover, &:active, &:focus
        background-color #e4e4e4
        padding 3px 8px 5px 3px
        border 3px solid #CACFD2
        border-radius 4px

  .desativado
    &:hover, &:active, &:focus
      background-color #ffffff !important
      padding 5px 10px 7px 5px
      border 0.1px solid #CACFD2
      border-radius 0px


</style>